
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pmark_signup",
      function () {
        return require("private-next-pages/pmark_signup/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pmark_signup"])
      });
    }
  